// extracted by mini-css-extract-plugin
module.exports = {"popover":"_fd9cb9a","columnSettings":"_b469177"};